<template>
    <div id='iframe_pl'>
        <h1 style='text-align:center'>{{diconame}}</h1>
        <iframe id="iframe_dictionnary" 
            :src="iframe_src"
            width="100%" style="height: calc(100% - 45px); border: none;"
            :style="{ display: visibility}"
            >
        </iframe>
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { diagonalbackURL, defaultConfig, URLEncodedConfig } from "../constantes";
    import axios from 'axios'

    export default { 
        name:"DicoFrame",
        mixins: [FctUtils],
        props: {
            diconame : {type:String},
            word : { type:String },
            settingObjStr:{type:String},
        },
        data(){
            return {
                settingObj: {},
                status:"",
                visibility: 'none'
            }
        },
        watch: {
            // whenever question changes, this function will run
            status: function (newStatus, oldStatus) {
                if (newStatus == 500) {
                    this.errorDicoName();
                }
            }
        },
        created() {
        },
        mounted() {
            // On écoute les messages émis depuis le dictionnaire personnel.
            // Si un mot est mis a jour, il faut mettre a jour le compteur pour envoyé les modifs
            //
            window.addEventListener('message', this.handleMessageFromIframe);
        },
        unmounted() {
            // On retire le handler 
            window.removeEventListener('message', this.handleMessageFromIframe);
        },
        computed : {
            iframe_src : function () {
                // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
                if (!FctUtils.methods.noEmpty(this.settingObjStr)) {
                    this.settingObj = this.$store.getters.setting;
                }
                else {
                    this.settingObj = JSON.parse(this.settingObjStr);
                }

                // dictionary?name=Cassetin2&setting=2
                var url = diagonalbackURL + '/dictionary?setting=' + this.settingObj.id + '&name=' + this.diconame +'&referer='+ window.location.protocol +'//'+ window.location.host;
                if (this.word) {
                    url += '&add='+this.word;
                }            
                /*var url = diagonalbackURL + "/settings/" + this.settingObj.id + "/dictionaries/" + this.diconame;
                if (this.word) {
                    url += '&add='+this.word;
                }*/            
                return url;
            }
        },
        created() {
            axios.get(this.iframe_src, defaultConfig)
                .catch(error => FctUtils.methods.errorHandler(error));
        },
        methods : {
            errorDicoName() {
                this.$router.push({name:"NotFound", params: {diconame: this.diconame} })
            },
            handleMessageFromIframe(iEvent) {
                // A trouver un test permettant de savoir que les messages proviennent bien de notre
                // iframe.
                //
                if (typeof iEvent.data == 'string') {
                    console.log(iEvent.data)

                    var aData = JSON.parse(iEvent.data);
                    
                    switch(aData.msg) {
                        // L'iframe est prête.
                        //
                        case 'readyForAction':
                            // On rend visible
                            //
                            this.visibility = '';
                        break;

                        case 'endModal':
                            // On augmente pas le compteur (du bouton) dans ce cas, s'il y a eu modification/ajout/supp
                            // le comtpeur a été mis a jour dans "updateWord"
                            this.backToSubmission();
                        break;
                        
                        case 'updateWord':
                            const params = { ...URLEncodedConfig };
                            params.data = 'word='+ this.word;
                            var self = this;

                            this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);

                            // Si on vient des soumissions, on y supprime le mot qui a été envoyé
                            // Et on retourne vers cette page
                            if (this.word != undefined && this.word != '') {
                                axios.delete(diagonalbackURL + "/settings/"+ this.settingObj.id + "/submissions",  params)
                                .then(reponse => { })
                                .catch(error => FctUtils.methods.errorHandler(error))
                                .then(() => {
                                    self.backToSubmission();
                                });
                            }
                        break;

                        case 'deleteLine':
                            this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        break;
                    }
                }
            },
            backToSubmission() {
                this.$router.push({name:"Submission"});
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


#iframe_pl {
    height : 100%;
}

</style>
